import type { WebStatusUpdate } from "@shared/services/salesforce/types";
import type { ResolvedStatus } from "./resolve-web-status";

// Maps a row's display webStatus to the WebStatusUpdate enum the approval-
// request contract expects. "Pending" / "Rejected" have no contract value
// (they're transient SF approval states) and resolve to undefined so callers
// can omit the field entirely instead of sending a bogus value.
//
// "Visible but not for Sale" means the SKU is on the storefront but cannot be
// bought, so it carries the same contract value as Out of Stock — matching how
// the Status cell presents it. Without this entry the mapper returned undefined
// and `buildShipToCurrentValues` silently substituted the caller's fallback,
// which is derived from the roaster's own row-level status, so a destination
// carrying this status submitted the wrong `currentWebStatus`.
const DISPLAY_TO_UPDATE: Partial<Record<ResolvedStatus, WebStatusUpdate>> = {
  "Visible for Sale": "Publish",
  "Out of Stock": "OutOfStock",
  "Visible but not for Sale": "OutOfStock",
  "Not Visible": "Unpublish",
};

export const toWebStatusUpdate = (status: ResolvedStatus | undefined): WebStatusUpdate | undefined =>
  status ? DISPLAY_TO_UPDATE[status] : undefined;
